import {
  constants,
  tooltipsConstants,
  updateOptionsInSelect,
  createSelectElement,
  createInputFields,
  createStats,
  getTooltips,
  createTooltip,
} from './refrigerant-calculator-helpers.js';

const { EXISTING_SHIP, NEW_BUILD } = constants;

const CURRENT_REFRIGERANT_ID = 'current-refrigerant';
const RETROFIT_REFRIGERANT_ID = 'retrofit-refrigerant';
const LOW_REFRIGERANT_ID = 'low-refrigerant';
const HIGH_REFRIGERANT_ID = 'high-refrigerant';

const RETROFIT_PLACEHOLDER = 'Select Retrofit Refrigerant';
const REFRIGERANT_PLACEHOLDER = 'Select Refrigerant';
const RETROFIT_LABEL = 'Retrofit Refrigerant';

const showStatsContainer = (data, type) => {
  const calculatorEl = document.querySelector('.refrigerant-calculator');
  const refrigerantStats = calculatorEl.querySelector('.refrigerant-stats');

  const stats = createStats({ items: data, type });

  if (refrigerantStats) {
    refrigerantStats.remove();
  }
  calculatorEl.append(stats);
};

const submitNewBuildData = (type) => {
  const lowRefrigerantSelect = document.getElementById(LOW_REFRIGERANT_ID);
  const highRefrigerantSelect = document.getElementById(HIGH_REFRIGERANT_ID);
  const totalQuantityInput = document.getElementById(`${type}-quantity`);
  const unitInput = document.getElementById(`${type}-unit`);
  const leakageInput = document.getElementById(`${type}-leakage-rate`);

  const isRefrigerantSelected =
    lowRefrigerantSelect.selectedIndex > 0 &&
    highRefrigerantSelect.selectedIndex > 0;
  const isQuantityPositiveNum = Number(totalQuantityInput.value) > 0;

  const isValidData = isRefrigerantSelected && isQuantityPositiveNum;

  if (isValidData) {
    const lowData = lowRefrigerantSelect.selectedOptions[0].dataset;
    const lowId = Number(lowData.id);

    const highData = highRefrigerantSelect.selectedOptions[0].dataset;
    const highId = Number(highData.id);

    const amount = Number(totalQuantityInput.value);

    const unit = unitInput.selectedIndex;

    const leakageRate = Number(leakageInput.value) / 100;

    const reqBody = {
      HighGwpId: highId,
      LowGwpId: lowId,
      CalculatorType: 0,
      Amount: amount,
      Unit: unit,
      AnnualLeakageRate: leakageRate,
    };

    fetch(`${window.location.origin}/api/refrigerantcalculator/Calculate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(reqBody),
    })
      .then((response) => response.json())
      .then((data) => {
        showStatsContainer(data, NEW_BUILD);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
};

const submitExistingShipData = (type) => {
  const currentRefrigerantSelect = document.getElementById(
    CURRENT_REFRIGERANT_ID
  );
  const retrofitRefrigerantSelect = document.getElementById(
    RETROFIT_REFRIGERANT_ID
  );
  const totalQuantityInput = document.getElementById(`${type}-quantity`);
  const unitInput = document.getElementById(`${type}-unit`);
  const periodInput = document.getElementById(`${type}-period`);

  const isRefrigerantSelected =
    currentRefrigerantSelect.selectedIndex > 0 &&
    retrofitRefrigerantSelect.selectedIndex > 0;
  const isQuantityPositiveNum = Number(totalQuantityInput.value) > 0;

  const isValidData = isRefrigerantSelected && isQuantityPositiveNum;

  if (isValidData) {
    const currentData = currentRefrigerantSelect.selectedOptions[0].dataset;
    const currentId = Number(currentData.id);

    const retrofitData = retrofitRefrigerantSelect.selectedOptions[0].dataset;
    const retrofitId = Number(retrofitData.id);

    const periodData = periodInput.selectedOptions[0].dataset;
    const periodId = Number(periodData.id);

    const amount = Number(totalQuantityInput.value);

    const unit = unitInput.selectedIndex;

    const reqBody = {
      HighGwpId: currentId,
      LowGwpId: retrofitId,
      CalculatorType: 1,
      Amount: amount,
      Unit: unit,
      Period: periodId,
    };

    fetch(`${window.location.origin}/api/refrigerantcalculator/Calculate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(reqBody),
    })
      .then((response) => response.json())
      .then((data) => {
        showStatsContainer(data, EXISTING_SHIP);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
};

const createExistingShipTab = (data) => {
  const existingShipEl = document.querySelector(
    '.refrigerant-calculator__existing-ship'
  );

  const submitButtonEl = document.createElement('button');
  submitButtonEl.innerHTML = 'Calculate your gain';
  submitButtonEl.style.marginTop = 'auto';

  submitButtonEl.addEventListener('click', () =>
    submitExistingShipData(EXISTING_SHIP)
  );

  const handleCurrentSelectChange = (index) => {
    updateOptionsInSelect({
      id: RETROFIT_REFRIGERANT_ID,
      items: index > 0 ? retrofitRefrigerantOptions[index - 1] : [],
      placeholder: RETROFIT_PLACEHOLDER,
    });
  };

  const currentRefrigerantOptions = data.map((item) => {
    const el = item.MainRefrigerant;
    const { Gwp, Name, Id } = el;

    return {
      name: `${Name} (${Gwp} GWP - AR4)`,
      id: Id,
    };
  });
  const retrofitRefrigerantOptions = data.map((item) => {
    const items = item.RelatedRefrigerants;
    const list = items.map((item) => {
      const { Name, Gwp, Id } = item;

      return {
        name: `${Name} (${Gwp} GWP - AR4)`,
        id: Id,
      };
    });
    return list;
  });

  const currentRefrigerantSelect = createSelectElement({
    label: 'Current Refrigerant',
    placeholder: REFRIGERANT_PLACEHOLDER,
    items: currentRefrigerantOptions,
    id: CURRENT_REFRIGERANT_ID,
    onChange: handleCurrentSelectChange,
  });

  const retrofitRefrigerantSelect = createSelectElement({
    label: RETROFIT_LABEL,
    placeholder: RETROFIT_PLACEHOLDER,
    items: [],
    id: RETROFIT_REFRIGERANT_ID,
  });

  const inputFields = createInputFields(EXISTING_SHIP);

  existingShipEl.append(
    currentRefrigerantSelect.labelEl,
    currentRefrigerantSelect.selectEl,
    inputFields,
    retrofitRefrigerantSelect.labelEl,
    retrofitRefrigerantSelect.selectEl,
    submitButtonEl
  );
};

const createNewBuildTab = (data) => {
  const tooltipsList = getTooltips();
  const { HELP_TEXT_LOW_GWP_REFRIGERANT, HELP_TEXT_HIGH_GWP_REFRIGERANT } =
    tooltipsConstants;

  const newBuildEl = document.querySelector(
    '.refrigerant-calculator__new-build'
  );

  const submitButtonEl = document.createElement('button');
  submitButtonEl.innerHTML = 'Calculate your gain';
  submitButtonEl.style.marginTop = 'auto';

  submitButtonEl.addEventListener('click', () => submitNewBuildData(NEW_BUILD));

  const handleCurrentSelectChange = (index) => {
    updateOptionsInSelect({
      id: HIGH_REFRIGERANT_ID,
      items: index > 0 ? highRefrigerantOptions[index - 1] : [],
      placeholder: REFRIGERANT_PLACEHOLDER,
    });
  };

  const lowRefrigerantOptions = data.map((item) => {
    const el = item.MainRefrigerant;
    const { Gwp, Name, Id } = el;

    return {
      name: `${Name} (${Gwp} GWP - AR4)`,
      id: Id,
    };
  });

  const highRefrigerantOptions = data.map((item) => {
    const items = item.RelatedRefrigerants;
    const list = items.map((item) => {
      const { Name, Gwp, Id } = item;

      return {
        name: `${Name} (${Gwp} GWP - AR4)`,
        id: Id,
      };
    });
    return list;
  });

  const lowRefrigerantSelect = createSelectElement({
    label: 'Low GWP Refrigerant',
    placeholder: REFRIGERANT_PLACEHOLDER,
    items: lowRefrigerantOptions,
    id: LOW_REFRIGERANT_ID,
    onChange: handleCurrentSelectChange,
  });
  const lowRefrigerantTooltip = createTooltip(
    tooltipsList[HELP_TEXT_LOW_GWP_REFRIGERANT]
  );
  lowRefrigerantSelect.labelEl.append(lowRefrigerantTooltip);

  const highRefrigerantSelect = createSelectElement({
    label: 'High GWP Refrigerant',
    placeholder: REFRIGERANT_PLACEHOLDER,
    items: [],
    id: HIGH_REFRIGERANT_ID,
  });
  const highRefrigerantTooltip = createTooltip(
    tooltipsList[HELP_TEXT_HIGH_GWP_REFRIGERANT]
  );
  highRefrigerantSelect.labelEl.append(highRefrigerantTooltip);

  const inputFields = createInputFields(NEW_BUILD);

  newBuildEl.append(
    lowRefrigerantSelect.labelEl,
    lowRefrigerantSelect.selectEl,
    inputFields,
    highRefrigerantSelect.labelEl,
    highRefrigerantSelect.selectEl,
    submitButtonEl
  );
};

(function () {
  const calculatorEl = document.querySelector('.refrigerant-calculator');

  if (calculatorEl) {
    fetch(`${window.location.origin}/api/refrigerantcalculator/GetInitialData`)
      .then((response) => response.json())
      .then((refrigerantsData) => {
        const {
          ExistingShipRefrigerantsRelationship,
          NewBuildRefrigerantsRelationship,
        } = refrigerantsData;

        createExistingShipTab(ExistingShipRefrigerantsRelationship);
        createNewBuildTab(NewBuildRefrigerantsRelationship);
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    const wrapperEl = calculatorEl.querySelector(
      '.refrigerant-calculator__wrapper'
    );
    const navEl = wrapperEl.querySelector('.refrigerant-calculator__nav');
    const existingShipEl = wrapperEl.querySelector(
      '.refrigerant-calculator__existing-ship'
    );
    const newBuildEl = wrapperEl.querySelector(
      '.refrigerant-calculator__new-build'
    );

    const existingShipBtn = navEl.querySelector(
      '.refrigerant-calculator__nav-btn--existing'
    );
    const newBuildBtn = navEl.querySelector(
      '.refrigerant-calculator__nav-btn--new'
    );

    const setActiveTab = (tab) => {
      if (tab === EXISTING_SHIP) {
        const isActive =
          existingShipBtn.parentElement.classList.contains('is-active');

        if (!isActive) {
          existingShipBtn.parentElement.classList.add('is-active');
          existingShipEl.classList.add('is-active');

          newBuildBtn.parentElement.classList.remove('is-active');
          newBuildEl.classList.remove('is-active');
        }
      } else if (tab === NEW_BUILD) {
        const isActive =
          newBuildBtn.parentElement.classList.contains('is-active');

        if (!isActive) {
          newBuildBtn.parentElement.classList.add('is-active');
          newBuildEl.classList.add('is-active');

          existingShipBtn.parentElement.classList.remove('is-active');
          existingShipEl.classList.remove('is-active');
        }
      }
    };

    existingShipBtn.addEventListener('click', () =>
      setActiveTab(EXISTING_SHIP)
    );
    newBuildBtn.addEventListener('click', () => setActiveTab(NEW_BUILD));
  }
})();
